module.exports = __webpack_public_path__ + "assets/img/27_1169_big.bea78432.jpg";